export default __webpack_public_path__ + "static/media/healthy.30f422d1.svg";